import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { Query } from "../driver/Query";
import { SqlInMemory } from "../driver/SqlInMemory";
import { TypeORMError } from "../error/TypeORMError";
import { OrmUtils } from "../util/OrmUtils";
import { InstanceChecker } from "../util/InstanceChecker";
export var BaseQueryRunner = /*#__PURE__*/function () {
  function BaseQueryRunner() {
    _classCallCheck(this, BaseQueryRunner);
    // -------------------------------------------------------------------------
    // Public Properties
    // -------------------------------------------------------------------------
    /**
     * Indicates if connection for this query runner is released.
     * Once its released, query runner cannot run queries anymore.
     */
    this.isReleased = false;
    /**
     * Indicates if transaction is in progress.
     */
    this.isTransactionActive = false;
    /**
     * Stores temporarily user data.
     * Useful for sharing data with subscribers.
     */
    this.data = {};
    /**
     * All synchronized tables in the database.
     */
    this.loadedTables = [];
    /**
     * All synchronized views in the database.
     */
    this.loadedViews = [];
    /**
     * Indicates if special query runner mode in which sql queries won't be executed is enabled.
     */
    this.sqlMemoryMode = false;
    /**
     * Sql-s stored if "sql in memory" mode is enabled.
     */
    this.sqlInMemory = new SqlInMemory();
    /**
     * current depth of transaction.
     * for transactionDepth > 0 will use SAVEPOINT to start and commit/rollback transaction blocks
     */
    this.transactionDepth = 0;
    this.cachedTablePaths = {};
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Called before migrations are run.
   */
  _createClass(BaseQueryRunner, [{
    key: "beforeMigration",
    value: function () {
      var _beforeMigration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function beforeMigration() {
        return _beforeMigration.apply(this, arguments);
      }
      return beforeMigration;
    }()
    /**
     * Called after migrations are run.
     */
  }, {
    key: "afterMigration",
    value: function () {
      var _afterMigration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function afterMigration() {
        return _afterMigration.apply(this, arguments);
      }
      return afterMigration;
    }()
    /**
     * Loads given table's data from the database.
     */
  }, {
    key: "getTable",
    value: function () {
      var _getTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(tablePath) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.loadTables([tablePath]);
            case 2:
              this.loadedTables = _context3.sent;
              return _context3.abrupt("return", this.loadedTables.length > 0 ? this.loadedTables[0] : undefined);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getTable(_x) {
        return _getTable.apply(this, arguments);
      }
      return getTable;
    }()
    /**
     * Loads all tables (with given names) from the database.
     */
  }, {
    key: "getTables",
    value: function () {
      var _getTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(tableNames) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (tableNames) {
                _context4.next = 4;
                break;
              }
              _context4.next = 3;
              return this.loadTables(tableNames);
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
              _context4.next = 6;
              return this.loadTables(tableNames);
            case 6:
              this.loadedTables = _context4.sent;
              return _context4.abrupt("return", this.loadedTables);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getTables(_x2) {
        return _getTables.apply(this, arguments);
      }
      return getTables;
    }()
    /**
     * Loads given view's data from the database.
     */
  }, {
    key: "getView",
    value: function () {
      var _getView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(viewPath) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.loadViews([viewPath]);
            case 2:
              this.loadedViews = _context5.sent;
              return _context5.abrupt("return", this.loadedViews.length > 0 ? this.loadedViews[0] : undefined);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getView(_x3) {
        return _getView.apply(this, arguments);
      }
      return getView;
    }()
    /**
     * Loads given view's data from the database.
     */
  }, {
    key: "getViews",
    value: function () {
      var _getViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(viewPaths) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.loadViews(viewPaths);
            case 2:
              this.loadedViews = _context6.sent;
              return _context6.abrupt("return", this.loadedViews);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getViews(_x4) {
        return _getViews.apply(this, arguments);
      }
      return getViews;
    }()
    /**
     * Enables special query runner mode in which sql queries won't be executed,
     * instead they will be memorized into a special variable inside query runner.
     * You can get memorized sql using getMemorySql() method.
     */
  }, {
    key: "enableSqlMemory",
    value: function enableSqlMemory() {
      this.sqlInMemory = new SqlInMemory();
      this.sqlMemoryMode = true;
    }
    /**
     * Disables special query runner mode in which sql queries won't be executed
     * started by calling enableSqlMemory() method.
     *
     * Previously memorized sql will be flushed.
     */
  }, {
    key: "disableSqlMemory",
    value: function disableSqlMemory() {
      this.sqlInMemory = new SqlInMemory();
      this.sqlMemoryMode = false;
    }
    /**
     * Flushes all memorized sqls.
     */
  }, {
    key: "clearSqlMemory",
    value: function clearSqlMemory() {
      this.sqlInMemory = new SqlInMemory();
    }
    /**
     * Gets sql stored in the memory. Parameters in the sql are already replaced.
     */
  }, {
    key: "getMemorySql",
    value: function getMemorySql() {
      return this.sqlInMemory;
    }
    /**
     * Executes up sql queries.
     */
  }, {
    key: "executeMemoryUpSql",
    value: function () {
      var _executeMemoryUpSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _iterator, _step, _step$value, query, parameters;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(this.sqlInMemory.upQueries);
              _context7.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context7.next = 9;
                break;
              }
              _step$value = _step.value, query = _step$value.query, parameters = _step$value.parameters;
              _context7.next = 7;
              return this.query(query, parameters);
            case 7:
              _context7.next = 3;
              break;
            case 9:
              _context7.next = 14;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](1);
              _iterator.e(_context7.t0);
            case 14:
              _context7.prev = 14;
              _iterator.f();
              return _context7.finish(14);
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 11, 14, 17]]);
      }));
      function executeMemoryUpSql() {
        return _executeMemoryUpSql.apply(this, arguments);
      }
      return executeMemoryUpSql;
    }()
    /**
     * Executes down sql queries.
     */
  }, {
    key: "executeMemoryDownSql",
    value: function () {
      var _executeMemoryDownSql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _iterator2, _step2, _step2$value, query, parameters;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.sqlInMemory.downQueries.reverse());
              _context8.prev = 1;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context8.next = 9;
                break;
              }
              _step2$value = _step2.value, query = _step2$value.query, parameters = _step2$value.parameters;
              _context8.next = 7;
              return this.query(query, parameters);
            case 7:
              _context8.next = 3;
              break;
            case 9:
              _context8.next = 14;
              break;
            case 11:
              _context8.prev = 11;
              _context8.t0 = _context8["catch"](1);
              _iterator2.e(_context8.t0);
            case 14:
              _context8.prev = 14;
              _iterator2.f();
              return _context8.finish(14);
            case 17:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[1, 11, 14, 17]]);
      }));
      function executeMemoryDownSql() {
        return _executeMemoryDownSql.apply(this, arguments);
      }
      return executeMemoryDownSql;
    }()
  }, {
    key: "getReplicationMode",
    value: function getReplicationMode() {
      return this.mode;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Gets view from previously loaded views, otherwise loads it from database.
     */
  }, {
    key: "getCachedView",
    value: function () {
      var _getCachedView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(viewName) {
        var view, foundViews;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              view = this.loadedViews.find(function (view) {
                return view.name === viewName;
              });
              if (!view) {
                _context9.next = 3;
                break;
              }
              return _context9.abrupt("return", view);
            case 3:
              _context9.next = 5;
              return this.loadViews([viewName]);
            case 5:
              foundViews = _context9.sent;
              if (!(foundViews.length > 0)) {
                _context9.next = 11;
                break;
              }
              this.loadedViews.push(foundViews[0]);
              return _context9.abrupt("return", foundViews[0]);
            case 11:
              throw new TypeORMError("View \"".concat(viewName, "\" does not exist."));
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getCachedView(_x5) {
        return _getCachedView.apply(this, arguments);
      }
      return getCachedView;
    }()
    /**
     * Gets table from previously loaded tables, otherwise loads it from database.
     */
  }, {
    key: "getCachedTable",
    value: function () {
      var _getCachedTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(tableName) {
        var _this = this;
        var tablePath, table, foundTables, foundTablePath, cachedTable;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(tableName in this.cachedTablePaths)) {
                _context10.next = 5;
                break;
              }
              tablePath = this.cachedTablePaths[tableName];
              table = this.loadedTables.find(function (table) {
                return _this.getTablePath(table) === tablePath;
              });
              if (!table) {
                _context10.next = 5;
                break;
              }
              return _context10.abrupt("return", table);
            case 5:
              _context10.next = 7;
              return this.loadTables([tableName]);
            case 7:
              foundTables = _context10.sent;
              if (!(foundTables.length > 0)) {
                _context10.next = 20;
                break;
              }
              foundTablePath = this.getTablePath(foundTables[0]);
              cachedTable = this.loadedTables.find(function (table) {
                return _this.getTablePath(table) === foundTablePath;
              });
              if (cachedTable) {
                _context10.next = 17;
                break;
              }
              this.cachedTablePaths[tableName] = this.getTablePath(foundTables[0]);
              this.loadedTables.push(foundTables[0]);
              return _context10.abrupt("return", foundTables[0]);
            case 17:
              return _context10.abrupt("return", cachedTable);
            case 18:
              _context10.next = 21;
              break;
            case 20:
              throw new TypeORMError("Table \"".concat(tableName, "\" does not exist."));
            case 21:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getCachedTable(_x6) {
        return _getCachedTable.apply(this, arguments);
      }
      return getCachedTable;
    }()
    /**
     * Replaces loaded table with given changed table.
     */
  }, {
    key: "replaceCachedTable",
    value: function replaceCachedTable(table, changedTable) {
      var _this2 = this;
      var oldTablePath = this.getTablePath(table);
      var foundTable = this.loadedTables.find(function (loadedTable) {
        return _this2.getTablePath(loadedTable) === oldTablePath;
      });
      // Clean up the lookup cache..
      for (var _i = 0, _Object$entries = Object.entries(this.cachedTablePaths); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          cachedPath = _Object$entries$_i[1];
        if (cachedPath === oldTablePath) {
          this.cachedTablePaths[key] = this.getTablePath(changedTable);
        }
      }
      if (foundTable) {
        foundTable.database = changedTable.database;
        foundTable.schema = changedTable.schema;
        foundTable.name = changedTable.name;
        foundTable.columns = changedTable.columns;
        foundTable.indices = changedTable.indices;
        foundTable.foreignKeys = changedTable.foreignKeys;
        foundTable.uniques = changedTable.uniques;
        foundTable.checks = changedTable.checks;
        foundTable.justCreated = changedTable.justCreated;
        foundTable.engine = changedTable.engine;
      }
    }
  }, {
    key: "getTablePath",
    value: function getTablePath(target) {
      var parsed = this.connection.driver.parseTableName(target);
      return this.connection.driver.buildTableName(parsed.tableName, parsed.schema, parsed.database);
    }
  }, {
    key: "getTypeormMetadataTableName",
    value: function getTypeormMetadataTableName() {
      var options = this.connection.driver.options;
      return this.connection.driver.buildTableName(this.connection.metadataTableName, options.schema, options.database);
    }
    /**
     * Generates SQL query to select record from typeorm metadata table.
     */
  }, {
    key: "selectTypeormMetadataSql",
    value: function selectTypeormMetadataSql(_ref) {
      var database = _ref.database,
        schema = _ref.schema,
        table = _ref.table,
        type = _ref.type,
        name = _ref.name;
      var qb = this.connection.createQueryBuilder();
      var selectQb = qb.select().from(this.getTypeormMetadataTableName(), "t").where("".concat(qb.escape("type"), " = :type"), {
        type: type
      }).andWhere("".concat(qb.escape("name"), " = :name"), {
        name: name
      });
      if (database) {
        selectQb.andWhere("".concat(qb.escape("database"), " = :database"), {
          database: database
        });
      }
      if (schema) {
        selectQb.andWhere("".concat(qb.escape("schema"), " = :schema"), {
          schema: schema
        });
      }
      if (table) {
        selectQb.andWhere("".concat(qb.escape("table"), " = :table"), {
          table: table
        });
      }
      var _selectQb$getQueryAnd = selectQb.getQueryAndParameters(),
        _selectQb$getQueryAnd2 = _slicedToArray(_selectQb$getQueryAnd, 2),
        query = _selectQb$getQueryAnd2[0],
        parameters = _selectQb$getQueryAnd2[1];
      return new Query(query, parameters);
    }
    /**
     * Generates SQL query to insert a record into typeorm metadata table.
     */
  }, {
    key: "insertTypeormMetadataSql",
    value: function insertTypeormMetadataSql(_ref2) {
      var database = _ref2.database,
        schema = _ref2.schema,
        table = _ref2.table,
        type = _ref2.type,
        name = _ref2.name,
        value = _ref2.value;
      var _this$connection$crea = this.connection.createQueryBuilder().insert().into(this.getTypeormMetadataTableName()).values({
          database: database,
          schema: schema,
          table: table,
          type: type,
          name: name,
          value: value
        }).getQueryAndParameters(),
        _this$connection$crea2 = _slicedToArray(_this$connection$crea, 2),
        query = _this$connection$crea2[0],
        parameters = _this$connection$crea2[1];
      return new Query(query, parameters);
    }
    /**
     * Generates SQL query to delete a record from typeorm metadata table.
     */
  }, {
    key: "deleteTypeormMetadataSql",
    value: function deleteTypeormMetadataSql(_ref3) {
      var database = _ref3.database,
        schema = _ref3.schema,
        table = _ref3.table,
        type = _ref3.type,
        name = _ref3.name;
      var qb = this.connection.createQueryBuilder();
      var deleteQb = qb.delete().from(this.getTypeormMetadataTableName()).where("".concat(qb.escape("type"), " = :type"), {
        type: type
      }).andWhere("".concat(qb.escape("name"), " = :name"), {
        name: name
      });
      if (database) {
        deleteQb.andWhere("".concat(qb.escape("database"), " = :database"), {
          database: database
        });
      }
      if (schema) {
        deleteQb.andWhere("".concat(qb.escape("schema"), " = :schema"), {
          schema: schema
        });
      }
      if (table) {
        deleteQb.andWhere("".concat(qb.escape("table"), " = :table"), {
          table: table
        });
      }
      var _deleteQb$getQueryAnd = deleteQb.getQueryAndParameters(),
        _deleteQb$getQueryAnd2 = _slicedToArray(_deleteQb$getQueryAnd, 2),
        query = _deleteQb$getQueryAnd2[0],
        parameters = _deleteQb$getQueryAnd2[1];
      return new Query(query, parameters);
    }
    /**
     * Checks if at least one of column properties was changed.
     * Does not checks column type, length and autoincrement, because these properties changes separately.
     */
  }, {
    key: "isColumnChanged",
    value: function isColumnChanged(oldColumn, newColumn, checkDefault, checkComment) {
      // this logs need to debug issues in column change detection. Do not delete it!
      // console.log("charset ---------------");
      // console.log(oldColumn.charset !== newColumn.charset);
      // console.log(oldColumn.charset, newColumn.charset);
      // console.log("collation ---------------");
      // console.log(oldColumn.collation !== newColumn.collation);
      // console.log(oldColumn.collation, newColumn.collation);
      // console.log("precision ---------------");
      // console.log(oldColumn.precision !== newColumn.precision);
      // console.log(oldColumn.precision, newColumn.precision);
      // console.log("scale ---------------");
      // console.log(oldColumn.scale !== newColumn.scale);
      // console.log(oldColumn.scale, newColumn.scale);
      // console.log("default ---------------");
      // console.log((checkDefault && oldColumn.default !== newColumn.default));
      // console.log(oldColumn.default, newColumn.default);
      // console.log("isNullable ---------------");
      // console.log(oldColumn.isNullable !== newColumn.isNullable);
      // console.log(oldColumn.isNullable, newColumn.isNullable);
      // console.log("comment ---------------");
      // console.log((checkComment && oldColumn.comment !== newColumn.comment));
      // console.log(oldColumn.comment, newColumn.comment);
      // console.log("enum ---------------");
      // console.log(!OrmUtils.isArraysEqual(oldColumn.enum || [], newColumn.enum || []));
      // console.log(oldColumn.enum, newColumn.enum);
      return oldColumn.charset !== newColumn.charset || oldColumn.collation !== newColumn.collation || oldColumn.precision !== newColumn.precision || oldColumn.scale !== newColumn.scale || oldColumn.width !== newColumn.width ||
      // MySQL only
      oldColumn.zerofill !== newColumn.zerofill ||
      // MySQL only
      oldColumn.unsigned !== newColumn.unsigned ||
      // MySQL only
      oldColumn.asExpression !== newColumn.asExpression || checkDefault && oldColumn.default !== newColumn.default || oldColumn.onUpdate !== newColumn.onUpdate ||
      // MySQL only
      oldColumn.isNullable !== newColumn.isNullable || checkComment && oldColumn.comment !== newColumn.comment || !OrmUtils.isArraysEqual(oldColumn.enum || [], newColumn.enum || []);
    }
    /**
     * Checks if column length is by default.
     */
  }, {
    key: "isDefaultColumnLength",
    value: function isDefaultColumnLength(table, column, length) {
      // if table have metadata, we check if length is specified in column metadata
      if (this.connection.hasMetadata(table.name)) {
        var metadata = this.connection.getMetadata(table.name);
        var columnMetadata = metadata.findColumnWithDatabaseName(column.name);
        if (columnMetadata) {
          var columnMetadataLength = this.connection.driver.getColumnLength(columnMetadata);
          if (columnMetadataLength) return false;
        }
      }
      if (this.connection.driver.dataTypeDefaults && this.connection.driver.dataTypeDefaults[column.type] && this.connection.driver.dataTypeDefaults[column.type].length) {
        return this.connection.driver.dataTypeDefaults[column.type].length.toString() === length.toString();
      }
      return false;
    }
    /**
     * Checks if column precision is by default.
     */
  }, {
    key: "isDefaultColumnPrecision",
    value: function isDefaultColumnPrecision(table, column, precision) {
      // if table have metadata, we check if length is specified in column metadata
      if (this.connection.hasMetadata(table.name)) {
        var metadata = this.connection.getMetadata(table.name);
        var columnMetadata = metadata.findColumnWithDatabaseName(column.name);
        if (columnMetadata && columnMetadata.precision !== null && columnMetadata.precision !== undefined) return false;
      }
      if (this.connection.driver.dataTypeDefaults && this.connection.driver.dataTypeDefaults[column.type] && this.connection.driver.dataTypeDefaults[column.type].precision !== null && this.connection.driver.dataTypeDefaults[column.type].precision !== undefined) return this.connection.driver.dataTypeDefaults[column.type].precision === precision;
      return false;
    }
    /**
     * Checks if column scale is by default.
     */
  }, {
    key: "isDefaultColumnScale",
    value: function isDefaultColumnScale(table, column, scale) {
      // if table have metadata, we check if length is specified in column metadata
      if (this.connection.hasMetadata(table.name)) {
        var metadata = this.connection.getMetadata(table.name);
        var columnMetadata = metadata.findColumnWithDatabaseName(column.name);
        if (columnMetadata && columnMetadata.scale !== null && columnMetadata.scale !== undefined) return false;
      }
      if (this.connection.driver.dataTypeDefaults && this.connection.driver.dataTypeDefaults[column.type] && this.connection.driver.dataTypeDefaults[column.type].scale !== null && this.connection.driver.dataTypeDefaults[column.type].scale !== undefined) return this.connection.driver.dataTypeDefaults[column.type].scale === scale;
      return false;
    }
    /**
     * Executes sql used special for schema build.
     */
  }, {
    key: "executeQueries",
    value: function () {
      var _executeQueries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(upQueries, downQueries) {
        var _this$sqlInMemory$upQ, _this$sqlInMemory$dow;
        var _iterator3, _step3, _step3$value, query, parameters;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (InstanceChecker.isQuery(upQueries)) upQueries = [upQueries];
              if (InstanceChecker.isQuery(downQueries)) downQueries = [downQueries];
              (_this$sqlInMemory$upQ = this.sqlInMemory.upQueries).push.apply(_this$sqlInMemory$upQ, _toConsumableArray(upQueries));
              (_this$sqlInMemory$dow = this.sqlInMemory.downQueries).push.apply(_this$sqlInMemory$dow, _toConsumableArray(downQueries));
              // if sql-in-memory mode is enabled then simply store sql in memory and return
              if (!(this.sqlMemoryMode === true)) {
                _context11.next = 6;
                break;
              }
              return _context11.abrupt("return", Promise.resolve());
            case 6:
              _iterator3 = _createForOfIteratorHelper(upQueries);
              _context11.prev = 7;
              _iterator3.s();
            case 9:
              if ((_step3 = _iterator3.n()).done) {
                _context11.next = 15;
                break;
              }
              _step3$value = _step3.value, query = _step3$value.query, parameters = _step3$value.parameters;
              _context11.next = 13;
              return this.query(query, parameters);
            case 13:
              _context11.next = 9;
              break;
            case 15:
              _context11.next = 20;
              break;
            case 17:
              _context11.prev = 17;
              _context11.t0 = _context11["catch"](7);
              _iterator3.e(_context11.t0);
            case 20:
              _context11.prev = 20;
              _iterator3.f();
              return _context11.finish(20);
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[7, 17, 20, 23]]);
      }));
      function executeQueries(_x7, _x8) {
        return _executeQueries.apply(this, arguments);
      }
      return executeQueries;
    }()
    /**
     * Generated an index name for a table and index
     */
  }, {
    key: "generateIndexName",
    value: function generateIndexName(table, index) {
      // new index may be passed without name. In this case we generate index name manually.
      return this.connection.namingStrategy.indexName(table, index.columnNames, index.where);
    }
  }]);
  return BaseQueryRunner;
}();